import React, { useState, useContext } from "react";
import { makeStyles, Box, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SettingsContext from "src/context/SettingsContext";

const useStyles = makeStyles((theme) => ({
  banner: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    background: "linear-gradient(90deg, #5f51de 0%, #ad5dd3 100%)",
    zIndex: 1300,
    padding: theme.spacing(1.5, 2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      gap: theme.spacing(0.5),
    },
  },
  text: {
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
  },
  claimButton: {
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    textDecoration: "underline",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "opacity 0.2s",
    "&:hover": {
      opacity: 0.8,
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(6),
    color: theme.palette.secondary.contrastText,
    padding: theme.spacing(0.5),
    backgroundColor: "transparent",
    "&:hover": {
      opacity: 0.8,
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  closeIcon: {
    fontSize: "20px",
  },
}));

const SaleBanner = () => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(true);
  const themeSeeting = useContext(SettingsContext);

  const handleClaimOffer = () => {
    // Navigate to get-started page
    window.location.href = "/secure/signup";

    // Alternative if using React Router:
    // import { useHistory } from "react-router-dom";
    // const history = useHistory();
    // history.push("/secure/get-started");
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Box className={classes.banner}>
      <Box className={classes.content}>
        <Typography className={classes.text}>
          First 3,000 users get 6 months of Premium features for free.
        </Typography>
        <Typography
          className={classes.claimButton}
          onClick={handleClaimOffer}
          component="span"
        >
          Claim Offer →
        </Typography>
      </Box>
      <IconButton
        className={classes.closeButton}
        onClick={handleClose}
        aria-label="Close banner"
        size="small"
      >
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
    </Box>
  );
};

export default SaleBanner;
